import React, { FC, useEffect, useState } from "react";
import { MyInput } from "pages/StepPages/StepTwo/MyInput/MyInput";
import { Button } from "components/shared";
import { useAppDispatch } from "toolkit/hooks";
import { createFolder, editDocument, editFolder } from "toolkit/documents/folders/folders.thunks";
import { useParams } from "react-router-dom";
import { IDocument, IFolder } from "toolkit/documents/folders/types";
import styles from "./AddingFolder.module.sass";

interface AddingFolderProps {
	title: string;
	folder?: IFolder;
	document?: IDocument;
	close: () => void;
}

export const AddingFolder: FC<AddingFolderProps> = ({ title, folder, document, close }) => {
	const [folderName, setFolderName] = useState<string>("");
	const { organizationId } = useParams();
	const [submitError, setSubmitError] = useState<boolean>(false);
	const [warningShown, setWarningShown] = useState<boolean>(false);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (folder) setFolderName(folder.name);
		else if (document) setFolderName(document.name);
		//eslint-disable-next-line
	}, []);

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!folderName.trim()) {
			setSubmitError(true);
		} else {
			setSubmitError(false);
			if (folder) {
				if (folder.name.trim() !== folderName.trim())
					dispatch(editFolder({ folderId: folder.id, folderName, close, showWarning }));
				else close();
			} else if (document) {
				if (document.name.trim() !== folderName.trim())
					dispatch(editDocument({ docId: document.id, folderName, close, showWarning }));
				else close();
			} else dispatch(createFolder({ organizationId: Number(organizationId), folderName, close, showWarning }));
		}
	};

	const showWarning = () => {
		setSubmitError(true);
		setWarningShown(true);
	};

	const changeValue = (value: string) => {
		if (warningShown) setWarningShown(false);
		setFolderName(value);
	};

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>{title}</h4>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles["form-wrp"]}>
					<MyInput
						className={styles.item}
						name={document ? "Название документа" : "Название папки"}
						placeholder={document ? "Устав от 20.03.2022" : "Учредительные документы"}
						value={folderName}
						set={(e) => changeValue(e.target.value)}
						required={true}
						condition={(submitError && !folderName.trim()) || warningShown}
						warning={{ text: "Название занято", condition: warningShown }}
					/>
				</div>
				<Button type="submit" className={styles.button}>
					Готово
				</Button>
			</form>
		</section>
	);
};
